import services from '../services'
import * as types from './mutation-types'

export const getAll = ({ commit }, params) => (
  services.list(params).then(res => {
    commit(types.SET_FORMS, res.data)
    return res.data
  })
)

export const show = async ({ commit }, id) => {
  await services.show(id).then(res => {
    commit(types.SET_FORM, res.data.data)
  })
}

export const showByGroup = async ({ commit }, id) => {
  await services.showByGroup(id).then(res => {
    commit(types.SET_FORM, res.data.data)
  })
}

export const save = async ({ commit }, obj) => {
  await services.save(obj).then(res => {
    commit(types.SET_FORM, res.data.data)
    return res
  })
}

export const deleteGroup = async ({ commit }, obj) => {
  await services.deleteGroup(obj).then(res => {
    return res
  })
}

export const deleteField = async ({ commit }, obj) => {
  await services.deleteField(obj).then(res => {
    return res
  })
}

export const changeStatus = async ({ commit }, obj) => {
  await services.changeStatus(obj).then(res => {
    return res
  })
}

export const deleteForm = async ({ commit }, id) => {
  const res = await services.deleteForm(id)
  return res.data
}
